import { Autocomplete, Box, FormControl, FormHelperText, InputLabel, TextField, ThemeProvider, createTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import countryData from "../../Assets/file/code_pays.json";
import Functions from '../../Helpers/Functions';
import { useTailwindBrand } from '../shared';

interface Country {
    label: string,
    value: number
}

interface SelectCountryProps {
    value?: string
    callBack: (value: string) => void
    error?: string
    required?: boolean
    label?: string
}

const countries: Country[] = countryData.sort((a, b) => a.label.localeCompare(b.label));

const SelectCountry = (props: SelectCountryProps) => {
    const { classes, brandConfig } = useTailwindBrand()
    const [selected, setSelected] = useState<Country | null>(null)

    useEffect(() => {
        if (props.value) {
            setSelected({
                label: props.value,
                value: Functions.getCodePays(props.value)
            })
            props.callBack(props.value)
        }
    }, [])

    const theme = createTheme({
        components: {
            MuiAutocomplete: {
                styleOverrides: {
                    option: { fontFamily: brandConfig.fontFamily },
                },
            },
        },
    });

    return (
        <div>
            <ThemeProvider theme={theme}>
                <FormControl variant="filled" fullWidth>
                    {/* <InputLabel
                        required={props.required}
                        className={`${classes.fontFamily} ${props.error ? classes.error : classes.text} border-2 font-semibold`}
                    >
                        {props.label ?? 'Pays de naissance'}
                    </InputLabel> */}
                    <Autocomplete
                        value={selected}
                        onChange={(_, newValue) => {
                            setSelected(newValue);
                            props.callBack(newValue ? newValue.label : "");
                        }}
                        id="country-select"
                        options={countries}
                        autoHighlight
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        getOptionLabel={(option) => option.label}
                        renderOption={(optProps, option) => (
                            <Box component="li" {...optProps}>
                                {option.label}
                            </Box>
                        )}
                        className={`${classes.fontFamily} ${props.error ? classes.errorBorder + ' border-l-4' : 'border-gray-400'} bg-white rounded-md border-2 `}
                        sx={{
                            fontFamily: brandConfig.fontFamily,
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="filled"
                                placeholder="Sélectionnez votre pays"
                                error={!!props.error}
                                className={`${classes.fontFamily} ${props.error ? classes.errorBorder + ' border-l-4' : 'border-gray-400'} bg-white rounded-md border-2`}
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                }}
                                sx={{
                                    '& .MuiFilledInput-root': {
                                        fontFamily: brandConfig.fontFamily,
                                        backgroundColor: 'transparent',
                                    },
                                    '& .MuiFilledInput-root::before': { border: 'none' },
                                    '& .MuiFilledInput-root::after': { border: 'none' },
                                    '& .MuiFilledInput-root:hover::before': { border: 'none' },
                                    '& input': { fontFamily: brandConfig.fontFamily },
                                }}
                                label={<label
                                    className={`${classes.fontFamily} ${props.error ? classes.error : classes.text} font-semibold`}>
                                    {props.label ?? 'Pays de naissance'}<span className={props.required ? 'text-red-700' : ''}>{" "}*</span> 
                                </label>}
                            />
                        )}
                    />
                </FormControl>
            </ThemeProvider>
            {props.error && (
                <FormHelperText className={`${classes.fontFamily} ${classes.error} italic font-semibold`}>
                    {props.error}
                </FormHelperText>
            )}
        </div>
    );
};

export default SelectCountry;
